<template>
  <DataTable
    v-redirect-if-no-permission:VEHICLE_TYPE_MANAGEMENT
    :url="api.ACTIONS.VEHICLE_TYPE"
    :titles="titles"
    :fieldsHiddenMain="['deleted_at']"
    :fieldsHiddenAdd="['id', 'created_at', 'deleted_at', 'updated_at']"
    :fieldsDisabledEdit="['id', 'created_at', 'deleted_at', 'updated_at']"
    :title="$t('monitoringPage.vehicleType.pageTitle')"
    :formatter="formatter"
    :fields-extra-add="extraEditor"
    :fields-extra-edit="extraEditor"
    :add-rules="rules(true)"
    :edit-rules="rules(false)"
    :fieldsExtraAdd="fieldsExtraAdd"
  />
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

export default {
  name: "VehicleType",
  title() {
    return this.$t("monitoringPage.vehicleType.pageTitle");
  },
  components: { DataTable },
  methods: {
    rules(add) {
      const number = (value) => {
        const pattern = /^\d+$/;
        if (!!value)
          return (
            pattern.test(value) ||
            this.$t("monitoringPage.vehicleType.ruleNumber")
          );
        else return true;
      };
      const required = (value) =>
        !!value || this.$t("monitoringPage.vehicleType.ruleRequired");
      return {
        max_seats_number: [number],
        priority: add ? [required, number] : [number],
        name: add ? [required] : [],
        icon: add ? [required] : [],
      };
    },
  },
  computed: {
    titles() {
      return {
        id: "#",
        name: this.$t("monitoringPage.common.name"),
        max_seats_number: this.$t("monitoringPage.vehicleType.colMaxSeats"),
        created_at: this.$t("monitoringPage.common.createdAt"),
        updated_at: this.$t("monitoringPage.common.updatedAt"),
      };
    },
    extraEditor() {
      return {
        icon: "choose-image-single",
      };
    },
    formatter() {
      const api = this.api;
      const vm = this;
      return {
        icon(value) {
          if (value == null) return vm.$t("monitoringPage.vehicleType.unloadable");
          if (value[0] !== "/") value = "/" + value;
          return `<img src="${
            api.IMAGES_URL + value
          }" style="max-width: 45px;max-height: 45px;" class="img-thumbnail"/>`;
        },
        created_at: (value) =>value != null ? formatCompanyTime(value, "DD-MM-YYYY - HH:mm") : null,
        updated_at: (value) => formatCompanyTime(value, "DD-MM-YYYY - HH:mm"),
      };
    },
    fieldsExtraAdd() {
      return {
        name: "v-text-field",
        icon: "choose-image-single",
      };
    },
  },
};
</script>

<style scoped>
.img-thumbnail {
  height: 40px;
  width: 40px;
}
</style>
